import { render } from "./VerticalNavMenu.vue?vue&type=template&id=07c0d134"
import script from "./VerticalNavMenu.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenu.vue?vue&type=script&lang=js"

import "./VerticalNavMenu.vue?vue&type=style&index=0&id=07c0d134&lang=scss"
script.render = render

export default script